export default {
  "supplierCollab": {
    "intro": "供应商基本资料来自 SAP，联系人与邮箱在此统一维护。",
    "contacts": "联系人与邮箱",
    "code": "供应商代码",
    "name": "SAP 供应商名称",
    "country": "国家",
    "language": "语言",
    "group": "SAP 科目组",
    "source": "资料来源",
    "legacy": "历史导入",
    "readonly": "基本资料由 SAP 同步，代码与名称只读。",
    "legacyHint": "此供应商尚未完成 SAP 关联，请先核对同步资料，再开通新联系人。",
    "search": "搜索供应商代码、名称或历史别名",
    "kind": "业务用途",
    "fabric": "面料",
    "trim": "辅料",
    "addContact": "新增联系人",
    "editContact": "编辑联系人",
    "emails": "通知邮箱",
    "primaryEmail": "主邮箱",
    "emailLabel": "邮箱备注",
    "account": "平台账号",
    "notificationOnly": "仅通知",
    "enableAccount": "开通供应商平台账号",
    "accountHint": "账号按人员独立开通；多个邮箱仅用于通知，不增加资料访问权限。",
    "addEmail": "添加邮箱",
    "emailInvalid": "请填写有效且不重复的邮箱，并指定一个主邮箱。",
    "disable": "停用",
    "disableConfirm": "停用此联系人并撤销其平台会话？历史发厂资料和回复记录继续保留。",
    "enableConfirm": "重新启用此联系人？",
    "bind": "关联已有联系人",
    "bindHint": "仅选择已核对身份的旧联系人，系统不会按供应商名称自动匹配。",
    "bindConfirm": "确认将 {name}（旧账号）关联至 {code} · {supplier}？此操作将留下审计记录。",
    "syncStatus": "SAP {system} · 来源 {n} 个 · 待同步 {pending} 个",
    "autoOn": "自动同步已启用",
    "autoOff": "自动同步未启用",
    "syncPreview": "预览供应商同步",
    "syncSummary": "来源 {n} 个，待同步 {pending} 个，异常 {errors} 个。",
    "syncBlocked": "存在来源异常，请先核对；本次预览不会写入供应商资料。",
    "syncChange": "变更",
    "syncCreate": "新增",
    "syncUpdate": "更新",
    "syncApply": "应用本批同步",
    "syncConfirm": "确认应用预览中的本批供应商同步（最多 {n} 个）？联系人、邮箱、账号和历史资料保持原有内容。",
    "syncApplied": "本批处理 {n} 个，剩余 {remaining} 个待同步。",
    "all": "全部",
    "actions": "操作",
    "saved": "已保存",
    "identityRequired": "此单尚未关联 SAP 供应商，请在生产信息中按代码选择后重新预览。",
    "copyContacts": "抄送联系人",
    "primaryContact": "主办联系人（负责确认）",
    "copyHint": "平台抄送联系人可查看本次资料；仅通知联系人只接收邮件，由主办提交确认。",
    "notifyEmails": "本次邮件收件地址",
    "noEmail": "所选联系人没有可用邮箱，可在供应商资料中补充，或选择仅发布至平台。",
    "noAddress": "请至少选择一个收件邮箱。",
    "manageContacts": "管理供应商联系人",
    "supplierReadonly": "供应商来自委托书生产信息，需修改时请返回委托书。",
    "deliveryStatus": "各邮箱投递情况",
    "changePrimary": "交接主办联系人",
    "changePrimaryConfirm": "确认将本次资料的主办交接给 {name}？历史回复保持并记录本次变更。",
    "primaryChanged": "主办已交接",
    "recipientRole": "收件角色",
    "primaryRole": "主办",
    "copyRole": "抄送",
    "retryDelivery": "重试此邮箱",
    "retryDeliveryConfirm": "仅重试发送到 {email} 的失败邮件？其他邮箱不会重复发送。",
    "accountsMoved": "供应商联系人和账号已统一到供应商管理。",
    "retryDone": "已提交失败邮箱重试",
    "emailOnly": "仅邮件通知",
    "platformPrimaryRequired": "请先为主办联系人开通供应商平台账号。",
    "productionSetup": "补齐生产信息",
    "productionSetupHint": "按供应商代码或名称选择供应商，并填写入库要求日。同一批次最多 20 款，须属于同一供应商；保存后预览工艺单。",
    "splitSupplierBatch": "所选款式属于不同供应商，请按供应商分别发送。仅在确需更换生产供应商时修改本单关联。",
    "saveAndPreview": "保存并预览",
    "productionSaveReview": "部分生产信息可能已保存，请刷新核对后继续。尚未发布给供应商。",
    "quickContactHint": "联系人将保存到当前供应商资料，并开通独立平台账号，供本批款式品牌使用。邮箱选填；取消发送也会保留已保存联系人。",
    "saveAndSelectContact": "保存并选用",
    "contactSavedForReuse": "联系人已保存到供应商资料，并选为本次主办。",
    "contactCreateUnconfirmed": "联系人创建结果尚未确认。请先刷新联系人，核对是否已创建；如已存在，请直接选用，避免重复新增。账号密码未收到时可在供应商资料中重置。",
    "credentialsHint": "请安全交付账号和初始密码给该联系人。密码仅本次显示，关闭后可在供应商资料中重置；不会写入邮件或工艺单。",
    "sapDetails": "供应商资料（SAP）",
    "moreActions": "更多操作",
    "accountActive": "已启用",
    "enableContact": "启用联系人",
    "noContacts": "暂无联系人",
    "deleteContact": "删除联系人",
    "deleteContactConfirm": "删除联系人「{name}」及其邮箱和平台账号？此操作不可撤销。",
    "contactInUse": "该联系人已有发厂或邮件记录，不能删除。请使用“停用”保留历史记录。",
    "contactDeleted": "联系人已删除",
    "deleteUnconfirmed": "删除结果尚未确认，请刷新联系人核对后再操作。",
    "refreshBeforeDelete": "请先刷新联系人，再执行删除。"
  }
};
